import React, { useState, useEffect, useRef, useCallback } from 'react';
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import AddPlatforms from './AddStreamingPlatforms';
import imgThumbnail from "../../../../img/thumbnail.png";
import { handleSongList } from '../../../../_services/creater/creatorSongList.service';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackBar, setSnackBarMessage, setSnackBarVariant } from '../../../../redux';
import { formSnackbar } from '../../../../_services/_constants/snackbar.constant';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeleteModal from '../../../../components/reusableComponents/DeleteModal';
import CreatePlaylistModal from '../playlist/CreatePlaylistModal';
import { Divider, Drawer, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import platform from '../../../../img/Platform.svg';
import playlist from '../../../../img/Playlist.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { updatePlateformSequence } from '../../../../_services/platform/platformSequence';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { handleRelatedPlatform } from '../../../../_services/creater/relatedPlatfom.service';
import { SkeletonWaveCard } from '../../../../_helpers/reusablefunctions/SkeletonCard';
import FirebaseImageStoreResizer from '../../../../_helpers/reusablefunctions/firebaseImageStoreResizer';
import LinkRoundedIcon from '@mui/icons-material/Link';
import { useHistory } from 'react-router-dom';
import { SHARE_SURFACE, getShareLinkStatus, hasShareLink } from '../../../../_services/creater/shareLink.service';
import TuneIcon from '@mui/icons-material/Tune';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
export const StreamingPlatformContext = React.createContext();

const AddSong = ({
  deleteSongHandler, index, id, data = {},
  allPlatfromList = [], reRenderPlatformHandler,
  allPlatfromListCopy = [], setAllPlatformList, setRelatedPlatform, relatedPlatform = [],
  provided, disableHandler, setPlaylistLoading, songsListData = [], getRelatedPlatforms,
  loading, playlistItems,
  getPlaylistList, setPlaylistItems, playlistLoading, renderSongList
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useSelector((state) => state.userData.userData);
  const smallViewport = useMediaQuery('(max-width:768px)');
  const [songTitle, setSongTitle] = useState(data.songTitle ?? '');
  const songSlug = data.slug ?? '';
  const [visiblityStatus, setVisibilityStatus] = useState(!!(data.visible && data.songTitle && data.related_platforms.length > 0));
  // This song's short URL, fetched on FIRST HOVER and not before.
  //   undefined  never asked
  //   false      asked, there is none yet
  //   object     the link
  // Probing every card as the list mounts would be thirty requests for a
  // tooltip nobody has asked to see; probing on hover is one request at the
  // moment the question is actually asked. The probe never mints, so a hover
  // cannot create a link by accident either.
  const [shortLink, setShortLink] = useState(undefined);
  // A song has no share surface until it has a row on the server, so the whole
  // control is inert until then — and says why, rather than just being grey.
  const savedSong = Boolean(data && data.id !== undefined);
  // MUI reopens the tooltip on every re-entry, so without this each pass of the
  // cursor would be another request for an answer we already have.
  const shortLinkAsked = useRef(false);
  const cardMounted = useRef(true);

  useEffect(() => {
    cardMounted.current = true;
    return () => { cardMounted.current = false; };
  }, []);

  const loadShortLink = useCallback(() => {
    if (!savedSong || shortLinkAsked.current) return;
    shortLinkAsked.current = true;
    getShareLinkStatus(SHARE_SURFACE.SONG, data.id).then((response) => {
      if (!cardMounted.current) return;
      setShortLink(hasShareLink(response) ? response.data : false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedSong, data && data.id]);
  const [songPoster, setSongPoster] = useState(
    data?.songPoster100x100
      ? data?.songPoster100x100
      : data.songPoster_url
        ? data.songPoster_url
        : data?.songPoster
          ? `${process.env.REACT_APP_BASEURL_MEDIA}/media/${data?.songPoster}`
          : data?.cover_image
            ? `${process.env.REACT_APP_SONGAPIURL3_MEDIA}${data?.cover_image}`
            : null
  );
  const [selectedFile, setSelectedFile] = useState();
  const [disableAddNewPlatform, setDisableAddNewPlatform] = useState(false);
  const [loaderClass, setLoaderClass] = useState('');
  const [errorSongTitle, setErrorSongTitle] = useState();
  const [disableViewStatus, setDisableViewStatus] = useState(!(data.id && songTitle));
  const bodyRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPlaylist, setOpenPlaylist] = useState(false);
  const { saveAvatar } = FirebaseImageStoreResizer({ selectedFile, functionCall: saveProfileAvatar });
  const openMenu = Boolean(anchorEl);

  const [posterInfo, setPosterInfo] = useState({ file: [], filepreview: null });
  const [invalidImage, setInvalidImage] = useState(null);
  const ref = useRef();
  const [open, setOpen] = useState(false);

  const isDisabled = data.is_admin_created;

  // Everything the profile toggle needs before it will turn on, in the order a
  // creator fills them. The switch was disabled with no way to find out why —
  // an "add song details" hint that never said WHICH detail, on a song where
  // four of them are separate fields on another screen.
  const filled = (value) => value !== undefined && value !== null && value !== '';
  const platformCount = (data.related_platforms && data.related_platforms.length) || 0;
  const visibilityBlockers = [
    !songTitle && 'a song title',
    !filled(data.artists) && 'an artist name',
    !filled(data.genre) && 'a genre',
    !filled(data.mood) && 'a mood',
    !filled(data.language) && 'a language',
    !platformCount && 'a streaming platform link',
  ].filter(Boolean);
  // The four in the middle live on the details page; the platform has its own
  // button on this card. Which of the two the hint points at depends on what is
  // actually missing, so it never sends anyone to the wrong screen.
  const missingDetails = visibilityBlockers.some((item) => item !== 'a song title' && item !== 'a streaming platform link');
  const missingPlatform = visibilityBlockers.indexOf('a streaming platform link') >= 0;
  const visibilityDisabled = disableViewStatus || visibilityBlockers.length > 0;

  const sentenceList = (items) => (items.length < 2
    ? items.join('')
    : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`);

  const visibilityHint = visibilityBlockers.length > 0
    ? `This song needs ${sentenceList(visibilityBlockers)} before it can go on your profile.`
      + (missingDetails ? ' Open Song details to add them.' : '')
      + (missingPlatform ? ' Add a platform with the + button.' : '')
    // Nothing missing but still off: a card whose song has not been saved yet.
    // Without this the hint would invite a click the control cannot accept.
    : visibilityDisabled
      ? 'Save this song first — the toggle turns on once it exists.'
      : visiblityStatus
        ? 'Showing on your profile. Switch off to hide it.'
        : 'Switch on to show this song on your profile.';

  // Handlers
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleOpenPlaylist = () => setOpenPlaylist((prev) => !prev);

  // The song's two screens. Named here because the kebab and the Setup chip
  // both go to the first one, and a copy of a route in two places is a route
  // that gets changed in one.
  const openSongDetails = () => history.push(
    `/songhub/music/${songSlug || data.id}`,
    // The list row travels with it: the page needs `is_admin_created` and the
    // poster, and handing the row over saves it a lookup on arrival.
    { song: data, songTitle: songTitle }
  );
  const openShortUrl = () => history.push(
    `/songhub/music/${songSlug || data.id}/short-url`,
    { songId: data.id, songTitle: songTitle }
  );

  const handleDrawerOpen = (id) => {
    getRelatedPlatforms(id);
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setRelatedPlatform([])
    setOpen(false);
    setDisableAddNewPlatform(false);
    setAllPlatformList(allPlatfromListCopy)
    renderSongList()
  }

  useEffect(() => {
    if (data.songPoster100x100) {
      setSongPoster(data.songPoster100x100);
    } else if (data.songPoster_url) {
      setSongPoster(data.songPoster_url);
    } else if (data?.songPoster) {
      setSongPoster(`${process.env.REACT_APP_BASEURL_MEDIA}/media/${data?.songPoster}`);
    } else if (data?.cover_image) {
      setSongPoster(`${process.env.REACT_APP_SONGAPIURL3_MEDIA}${data?.cover_image}`);
    } else {
      setSongPoster(null);
    }
  }, [data.songPoster_url, data?.cover_image]);

  useEffect(() => {
    if (selectedFile) saveAvatar();
  }, [selectedFile]);

  // Validation and change handlers
  const songTitleValidationHandler = (string) => {
    const regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/;
    const trimmed = string?.trim(); // remove spaces

    if (trimmed) {
      if (regex.test(trimmed)) return false;
      setErrorSongTitle(null);
      return true;
    }

    setVisibilityStatus(false);
    setErrorSongTitle("Please enter a valid song title");
    setDisableViewStatus(true);
    return false;
  };

  const songTitleChangeHandler = ({ value }) => {
    const trimmed = value.trim();
    setSongTitle(trimmed);

    const valid = songTitleValidationHandler(value);
    if (valid) {
      setErrorSongTitle(null);
      userData.id && id === undefined
        ? createSong({ songTitle: trimmed, visible: visiblityStatus })
        : updateSong({ songTitle: trimmed, visible: visiblityStatus });
    } else if (trimmed === "") {
      setErrorSongTitle("Please enter a valid song title");
    } else {
      setErrorSongTitle("Please enter a valid song title");
    }
  };


  const songThumbnailChangeHandler = (event) => {
    const imageFile = event.target.files[0];

    if (!imageFile) {
      setInvalidImage('Please select an image.');
      return;
    }

    if (!imageFile.name.match(/\.(jpg|jpeg|png|gif)$/i)) {
      setInvalidImage('Please select a valid image (JPG, JPEG, PNG, GIF).');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {

        if (img.width !== 3000 || img.height !== 3000) {
          setInvalidImage('Image must be exactly 3000x3000 pixels.');
          return;
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 600;
        canvas.height = 600;
        ctx.drawImage(img, 0, 0, 600, 600);

        canvas.toBlob((blob) => {
          const file = new File([blob], imageFile.name, {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });

          setPosterInfo(prev => ({
            ...prev,
            file,
            filepreview: URL.createObjectURL(file),
          }));

          setLoaderClass('uploadInProgress');
          setInvalidImage(null);
          setSelectedFile(imageFile);
        }, 'image/jpeg', 1);
      };

      img.onerror = () => {
        setInvalidImage('Could not load the image. Please try another one.');
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(imageFile);
  };

  const combineChangeHanddler = (event) => {
    setVisibilityStatus(event.target.checked);
    userData.id && id == undefined
      ? createSong({ visible: event.target.checked })
      : updateSong({ visible: event.target.checked });
  };

  function saveProfileAvatar({ original, thumbnails }) {
    console.debug("Image URLs:", {
      original,
      thumbnails
    });
    userData.id && id == undefined
      ? createSong({ songPosterThumbnail: original, imageResizer: thumbnails })
      : updateSong({ songPosterThumbnail: original, imageResizer: thumbnails });
  }

  // Create and update song
  const createSong = (postObj, type) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songCreate));
    dispatch(setSnackBarVariant('info'));
    const formData = new FormData();

    postObj.songPosterThumbnail && formData.append('songPoster_url', postObj?.songPosterThumbnail?.downloadURL);

    postObj.imageResizer && formData.append('songPoster100x100', postObj?.imageResizer[0].downloadURL);
    postObj.imageResizer && formData.append('songPoster300x300', postObj?.imageResizer[1].downloadURL);
    postObj.imageResizer && formData.append('songPoster300x150', postObj?.imageResizer[2].downloadURL);

    postObj.songTitle && formData.append('songTitle', postObj.songTitle);
    postObj.songSlug && formData.append('slug', postObj.songSlug);
    postObj?.musicDetailData?.genre && formData.append('genre', postObj.musicDetailData.genre);
    postObj?.musicDetailData?.mood && formData.append('mood', postObj.musicDetailData.mood);
    postObj?.musicDetailData?.language && formData.append('language', postObj.musicDetailData.language);
    postObj?.musicDetailData?.isrc && formData.append('isrc', postObj.musicDetailData.isrc);
    postObj?.musicDetailData?.artists && formData.append('artists', postObj.musicDetailData.artists);
    // The four columns on the detail serializer. Appended by presence like every
    // field above EXCEPT the two that can legitimately be cleared or false:
    // `about` and `record_label` are text a creator may want to empty, and
    // `is_explicit` is a boolean whose whole point is that `false` is a real
    // value — `&&` would silently drop all three the moment they were unset.
    if (postObj?.musicDetailData?.about !== undefined) {
      formData.append('about', postObj.musicDetailData.about);
    }
    if (postObj?.musicDetailData?.record_label !== undefined) {
      formData.append('record_label', postObj.musicDetailData.record_label);
    }
    if (postObj?.musicDetailData?.is_explicit !== undefined) {
      formData.append('is_explicit', postObj.musicDetailData.is_explicit);
    }
    // A DateField will not accept '', so an unset release date is skipped rather
    // than sent blank. Clearing one back to empty is not reachable from here.
    postObj?.musicDetailData?.release_date && formData.append('release_date', postObj.musicDetailData.release_date);
    postObj.visible !== undefined && formData.append('visible', postObj.visible);
    formData.append('song_order', songsListData.length < 1 ? '0' : index);
    if (songsListData.length > 0) {
      const songD = songsListData.map((item, idx) => ({
        songId: item.id ? item.id : 'null',
        index: idx,
      }));
      formData.append('songsList', JSON.stringify(songD));
    }
    if (type === 'UPDATE_ARITSTS') formData.append('artists', postObj.artists.join(','));
    if (type === 'UPDATE_TAGS') formData.append('tags', postObj.tags);
    formData.append('userId', userData.id);
    handleSongList(formData, 'POST')
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(setSnackBarMessage(formSnackbar.songPlaylist.songCreateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
          disableHandler();
          // renderSongList();
          bodyRef.current.focus();
        } else {
          dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch(() => {
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      })
      .finally(() => {
        renderSongList();
      })
  };

  const updateSong = (postObj, type) => {
    dispatch(setSnackBar(true));
    dispatch(setSnackBarMessage(postObj?.songSlug ? formSnackbar.songPlaylist.songSlugUpdate : formSnackbar.songPlaylist.songLinkUpdate));
    dispatch(setSnackBarVariant('info'));
    const formData = new FormData();
    postObj.songPosterThumbnail && formData.append('songPoster_url', postObj?.songPosterThumbnail?.downloadURL);

    postObj.imageResizer && formData.append('songPoster100x100', postObj?.imageResizer[0].downloadURL);
    postObj.imageResizer && formData.append('songPoster300x300', postObj?.imageResizer[1].downloadURL);
    postObj.imageResizer && formData.append('songPoster300x150', postObj?.imageResizer[2].downloadURL);

    postObj.songTitle && formData.append('songTitle', postObj.songTitle);
    postObj.songSlug && formData.append('slug', postObj.songSlug);
    postObj?.musicDetailData?.genre && formData.append('genre', postObj.musicDetailData.genre);
    postObj?.musicDetailData?.mood && formData.append('mood', postObj.musicDetailData.mood);
    postObj?.musicDetailData?.language && formData.append('language', postObj.musicDetailData.language);
    postObj?.musicDetailData?.isrc && formData.append('isrc', postObj.musicDetailData.isrc);
    postObj?.musicDetailData?.artists && formData.append('artists', postObj.musicDetailData.artists);
    // The four columns on the detail serializer. Appended by presence like every
    // field above EXCEPT the two that can legitimately be cleared or false:
    // `about` and `record_label` are text a creator may want to empty, and
    // `is_explicit` is a boolean whose whole point is that `false` is a real
    // value — `&&` would silently drop all three the moment they were unset.
    if (postObj?.musicDetailData?.about !== undefined) {
      formData.append('about', postObj.musicDetailData.about);
    }
    if (postObj?.musicDetailData?.record_label !== undefined) {
      formData.append('record_label', postObj.musicDetailData.record_label);
    }
    if (postObj?.musicDetailData?.is_explicit !== undefined) {
      formData.append('is_explicit', postObj.musicDetailData.is_explicit);
    }
    // A DateField will not accept '', so an unset release date is skipped rather
    // than sent blank. Clearing one back to empty is not reachable from here.
    postObj?.musicDetailData?.release_date && formData.append('release_date', postObj.musicDetailData.release_date);
    postObj.visible !== undefined && formData.append('visible', postObj.visible);
    if (type === 'UPDATE_ARITSTS') formData.append('artists', postObj.artists.join(','));
    if (type === 'UPDATE_TAGS') formData.append('tags', postObj.tags);
    formData.append('songId', id);
    formData.append('userId', userData.id);
    handleSongList(formData, 'UPDATE')
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(setSnackBarMessage(postObj?.songSlug ? formSnackbar.songPlaylist.songSlugUpdateSuccess : formSnackbar.songPlaylist.songLinkUpdateSuccess));
          dispatch(setSnackBarVariant('success'));
          setTimeout(() => dispatch(setSnackBar(false)), 3000);
          //
          disableHandler();
          setLoaderClass('');
          bodyRef.current.focus();
        } else {
          if (response.data?.slug?.length) {
            dispatch(setSnackBarMessage(response.data?.slug[0]));
          } else {
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          }
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch((error) => {
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      })
      .finally(() => {
        // renderSongList();
      })
  };

  // Platform handlers
  const handleAllPlatformList = (data, action) => {
    let localDataBKP = [...allPlatfromList];
    if (action === 'remove') {
      setAllPlatformList(localDataBKP.filter(entry1 => !data.some(entry2 => entry1?.platformId === entry2.streamingPlatform)));
    } else if (action === 'add') {
      let platform = allPlatfromListCopy.find(item => item?.platformId === data.streamingPlatform);
      setAllPlatformList([...allPlatfromList, platform]);
    } else if (action === 'update') {
      localDataBKP = localDataBKP.filter(item => item?.platformId !== data?.latestValue?.platformId);
      let platform = allPlatfromListCopy.find(item => item?.platformId === data.previousValue?.platformId);
      localDataBKP = [...localDataBKP, platform];
      setAllPlatformList(localDataBKP);
    }
  };

  const handleAddNewPlatform = () => {
    setRelatedPlatform([{}, ...relatedPlatform]);
    setDisableAddNewPlatform(true);
  };

  const deletePlatformHandler = (e, songid, relatedPlatformLinkId, idx, relatedPlatformData) => {
    let copyOfArray = [...relatedPlatform];
    if (copyOfArray.length > 0) {
      setRelatedPlatform(copyOfArray.filter(item => item.id !== relatedPlatformLinkId));
      setDisableAddNewPlatform(false);
      if (relatedPlatformLinkId !== undefined) {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.relatedPlatformDelete));
        dispatch(setSnackBarVariant('info'));
        if (JSON.stringify(copyOfArray[0]) === '{}') setDisableAddNewPlatform(true);
        let dataObj = {
          userId: userData.id,
          relatedPlatformLinkId,
          songId: songid
        };
        handleRelatedPlatform(dataObj, 'DELETE')
          .then((response) => {
            if (response.status === 200 || response.status === 204) {
              setTimeout(() => dispatch(setSnackBar(false)), 2000);
              dispatch(setSnackBarMessage(formSnackbar.relatedPlatform.relatedPlatformDeleteSuccess));
              dispatch(setSnackBarVariant('success'));
              handleAllPlatformList(relatedPlatformData, 'add');
            } else {
              dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
              dispatch(setSnackBarVariant('error'));
              setTimeout(() => dispatch(setSnackBar(false)), 2000);
            }
          })
          .catch(() => {
            dispatch(setSnackBar(true));
            dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
            dispatch(setSnackBarVariant('error'));
            setTimeout(() => dispatch(setSnackBar(false)), 2000);
          });
      }
    }
  };

  const addNewDisabledHandler = () => setDisableAddNewPlatform(false);

  // Platform drag and drop
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(relatedPlatform);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setRelatedPlatform(items);
    const data = items.map(song => song.id);
    let dataObj = { platform_ids: data.join(',') };
    updatePlateformSequence(userData.id, dataObj)
      .then((response) => {
        if (response.status === 200 || response.status === 204 || response.status === 201) {
          // renderSongList();
        } else {
          dispatch(setSnackBar(true));
          dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
          dispatch(setSnackBarVariant('error'));
          setTimeout(() => dispatch(setSnackBar(false)), 2000);
        }
      })
      .catch(() => {
        dispatch(setSnackBar(true));
        dispatch(setSnackBarMessage(formSnackbar.errors.errorMsg));
        dispatch(setSnackBarVariant('error'));
        setTimeout(() => dispatch(setSnackBar(false)), 2000);
      });
  };

  // Render
  return (
    <>
      <div
        ref={id !== undefined ? provided.innerRef : null}
        {...(id !== undefined ? provided.draggableProps : null)}
        {...(id !== undefined ? provided.dragHandleProps : null)}
        className="col-md-12 my-3 col-sm-12 col-12 song-card bg-white"
        id={`song_${id}`}
      >
        {/* ONE ROW OF A LIST, not a form. Cover art, the song's identity, and
            everything you can do to it behind a single kebab — the shape every
            link manager settled on, because a row you can scan beats a card you
            have to read. What was here before put four icon buttons, a "+"
            menu and a toggle around the outside of three labelled input boxes,
            which is why it stood 200px tall on a phone. Every field it had is
            still here; only the arrangement changed. */}
        <div className="song-row">
          <span className="song-row__drag" aria-hidden="true">
            <DragIndicatorIcon fontSize="small" />
          </span>

          {/* Cover art doubles as the upload target: the label covers the
              thumbnail, so the picture IS the button. */}
          <div className="song-row__art">
            <img
              id="pf-img"
              src={posterInfo?.filepreview ?? songPoster ?? imgThumbnail}
              onError={(e) => { e.target.src = imgThumbnail; }}
              alt=""
            />
            {!isDisabled && (
              <label
                htmlFor={`songPoster_${id}`}
                className="song-row__artOverlay"
                title="Please upload an image with the resolution of 3000*3000"
              >
                <PhotoCameraOutlinedIcon sx={{ fontSize: 17 }} />
              </label>
            )}
            <input
              className="song-row__artInput"
              type="file"
              name="profile_pic"
              id={`songPoster_${id}`}
              accept="image/*"
              onChange={songThumbnailChangeHandler}
              disabled={isDisabled}
            />
            {loaderClass && (
              <div className="song-row__artLoader">
                <div className="spinner-border spinner-border-sm text-light" role="status">
                  <span className="sr-only"></span>
                </div>
              </div>
            )}
          </div>

          {/* Title, address, tags — the three things that identify the song,
              still edited in place, now weighted like a heading and its
              subtitle rather than three identical grey boxes. */}
          <div className="song-row__body">
            <div className="song-row__titleLine">
              <div className="song-row__title">
                <EditText
                  name="song-title"
                  className={`${isDisabled ? 'blurred-disabled ' : ''} w-100`}
                  defaultValue={songTitle}
                  onSave={songTitleChangeHandler}
                  placeholder="Song title"
                  readonly={isDisabled}
                />
              </div>
              {isDisabled && <span className="song-row__badge">System generated</span>}
            </div>
            {errorSongTitle && (
              <div className="custom-tooltip">
                <span className="tooltip-text">{errorSongTitle}</span>
                <span className="top"></span>
              </div>
            )}

            {/* The address and the tags moved to the song's own page. A list
                row answers "which song is this" and nothing more; editing a
                slug or a tag is work, and work belongs on the screen built for
                it. */}
            {invalidImage && (
              <div className="custom-tooltip">
                <span className="tooltip-text">{invalidImage}</span>
                <span className="top"></span>
              </div>
            )}
          </div>

          <div className="song-row__actions">
            {/* The one thing on the row that is not a control: a song that
                cannot be published yet says so, in the colour of a warning,
                and pressing it opens the screen where the gaps are. */}
            {savedSong && visibilityBlockers.length > 0 && (
              <Tooltip arrow title={visibilityHint}>
                <button type="button" className="song-row__setup" onClick={openSongDetails}>
                  <BuildOutlinedIcon sx={{ fontSize: 15 }} />
                  <span className="song-row__setupLabel">Setup</span>
                </button>
              </Tooltip>
            )}

            {/* The hint hangs on the LABEL, not the input: a disabled checkbox
                fires no pointer events, so a tooltip on the control itself
                never opens — which is exactly when it is needed. */}
            <Tooltip arrow title={visibilityHint}>
              <label className="switch">
                <input
                  disabled={visibilityDisabled}
                  checked={visiblityStatus}
                  type="checkbox"
                  id={data.id}
                  role="switch"
                  aria-label={visibilityHint}
                  onChange={combineChangeHanddler}
                />
                <span className="slider round"></span>
              </label>
            </Tooltip>

            {/* Five actions, one button. They were five separate controls
                competing with the song's own name for the width of the row. */}
            <Tooltip arrow title="More actions">
              <button
                type="button"
                className="song-row__menu"
                aria-label="More actions"
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                // Opening the menu is what asks whether a short URL exists, so
                // the item can say "View" or "Create" rather than guessing.
                onClick={(event) => { loadShortLink(); handleClick(event); }}
              >
                <MoreVertIcon />
              </button>
            </Tooltip>

            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{ sx: { minWidth: 210, borderRadius: '12px', boxShadow: '0 12px 32px rgba(15,23,41,0.14)' } }}
            >
              <MenuItem disabled={!savedSong} onClick={() => { handleClose(); openSongDetails(); }}>
                <ListItemIcon><TuneIcon fontSize="small" /></ListItemIcon>
                <Typography variant="inherit">Song details</Typography>
              </MenuItem>
              <MenuItem disabled={!savedSong} onClick={() => { handleClose(); openShortUrl(); }}>
                <ListItemIcon><LinkRoundedIcon fontSize="small" /></ListItemIcon>
                <Typography variant="inherit">
                  {shortLink ? 'View short URL' : 'Create short URL'}
                </Typography>
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem disabled={id === undefined} onClick={() => { handleClose(); handleDrawerOpen(id); }}>
                <ListItemIcon><img src={platform} alt="" width={18} /></ListItemIcon>
                <Typography variant="inherit">Add platform</Typography>
              </MenuItem>
              <MenuItem disabled={id === undefined} onClick={() => { handleClose(); handleOpenPlaylist(); }}>
                <ListItemIcon><img src={playlist} alt="" width={18} /></ListItemIcon>
                <Typography variant="inherit">Add playlist</Typography>
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem
                disabled={isDisabled}
                onClick={() => {
                  handleClose();
                  if (data && data.id !== undefined) ref.current.handleOpen();
                  else deleteSongHandler(id, index);
                }}
                sx={{ color: '#EF4444' }}
              >
                <ListItemIcon><DeleteIcon fontSize="small" sx={{ color: '#EF4444' }} /></ListItemIcon>
                <Typography variant="inherit">Delete</Typography>
              </MenuItem>
            </Menu>

            <CreatePlaylistModal
              setPlaylistLoading={setPlaylistLoading}
              setPlaylistItems={setPlaylistItems}
              playlistLoading={playlistLoading}
              playlistItems={playlistItems}
              getPlaylistList={getPlaylistList}
              openPlaylist={openPlaylist}
              handleOpenPlaylist={handleOpenPlaylist}
              closeCreateModal={handleClose}
              songData={data}
              userId={userData && userData.id}
              songId={data.id}
            />
          </div>
        </div>
        <DeleteModal cardId={data && data.id} deleteHandler={deleteSongHandler} ref={ref} />
      </div>
      {/* Drawer for add platform */}
      <Drawer
        sx={{
          width: '500px',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: smallViewport ? '100%' : '500px',
            boxSizing: 'border-box',
          },
        }}
        anchor="right"
        open={open}
      >
        <div>
          <div className="p-3 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#0000000D' }}>
            <div><h5 className='m-0'>Add platform</h5></div>
            <div style={{ position: 'relative', top: '-5px' }}>
              <button title="Close" className="icononly-btn" onClick={handleDrawerClose}><CloseIcon /></button>
            </div>
          </div>
          <div className="px-4">
            <div className='text-end mt-3 mb-2'>
              <button
                className='gn-actionbtn'
                disabled={disableAddNewPlatform || allPlatfromList.length === 0 || isDisabled}
                onClick={handleAddNewPlatform}
              >ADD NEW</button>
            </div>
            {
              loading ? (
                <div>
                  {[1, 2, 3].map((i) => (
                    <SkeletonWaveCard key={i} />
                  ))}
                </div>
              ) : (
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="characters">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <StreamingPlatformContext.Provider value={{ allPlatfromList, handleAllPlatformList, allPlatfromListCopy }}>
                          {open && relatedPlatform.map((platform, idx) => (
                            <Draggable key={platform.id ?? idx} draggableId={String(platform.id ?? idx)} index={idx}>
                              {(provided) => (
                                <AddPlatforms
                                  key={platform.id ?? idx}
                                  deletePlatformHandler={deletePlatformHandler}
                                  reRenderPlatformHandler={reRenderPlatformHandler}
                                  addNewDisabledHandler={addNewDisabledHandler}
                                  cardData={platform}
                                  songId={id}
                                  cardId={platform.id}
                                  index={idx}
                                  allRelatedPlatforms={relatedPlatform}
                                  provided={provided}
                                />
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </StreamingPlatformContext.Provider>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              )}
          </div>
        </div>
      </Drawer>

      <div ref={bodyRef} tabIndex={-1} style={{ position: 'absolute', left: '-9999px' }}></div>
    </>
  );
};

export default AddSong;